module.exports = __webpack_public_path__ + "images/upgrade-prompts/fortnite.fe1c88f41c50dd16c42a.svg";